import {
  LOGIN_FAIL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  UPDATE_USER_INFO,
} from "../../constants/actions.js";
import { ApiURLs } from "../../../constant/ApiUrls.jsx";
import {  postData } from "../../../services/api.js";
import { NavigationRoutes } from "../../../constant/Routes.jsx";
import localStorageServices from "../../../services/LocalStorage.js";
import { LocalStorageKeys } from "../../../constant/LocalStorageKeys.jsx";
// import Success_Icon_yellow from '../../../components/assests/image/Success_Icon_yellow.svg'


export const fetchUsers = (data, navigate) => {
  return async (dispatch) => {
    const url = ApiURLs.login;
    // wait untill the data not received so getData function take data and url part
    dispatch(loginRequest());
    try {
      var userResData = await postData(data,url);
      console.log(`response when we try to login ${JSON.stringify(userResData)}`)
      if (userResData.status === 1) {
        localStorageServices.setItem(LocalStorageKeys.userToken,{token:userResData.data.token});
        dispatch(loginSuccess(userResData.data));
        localStorageServices.setItem(LocalStorageKeys.userInfo,userResData.data.user_info);
        navigate(NavigationRoutes.ADMIN_DASHBOARD,{ replace: true });
      } else {
        dispatch(loginFailure());
      }
    } catch (error) {
      dispatch(loginFailure());
      console.log(`error while try to login ${error}`)
    }
  }
};


export const loginRequest = () => {
  return {
    type: LOGIN_REQUEST,
  };
};

export const loginSuccess = (users) => {
  return {
    type: LOGIN_SUCCESS,
    payload: users,
  };
};
export const updateUserInfo = (updatedUser) => ({
  type: UPDATE_USER_INFO,
  payload: updatedUser,
});


export const loginFailure = () => {
  return {
    type: LOGIN_FAIL,
  };
};

export const logout = () => {
  return {
    type: LOGOUT,
  };
};
